import axios from 'axios';
import { getUserLocalStorage } from '../context/util';

export const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

api.interceptors.request.use(
  (config : any) => {
    const user = getUserLocalStorage()
    if(user && user.accessToken) {
      config.headers.Authorization = `Bearer ${user.accessToken}`;
    }
    return config;
  }
);

api.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  if(err.response.status === 401) {
    localStorage.clear();
    window.location.reload()
  }
  return Promise.reject(err);
})
